export default "__VITE_ASSET__C_5TcDHY__"